export const isExportCustomer = (userFolder = '') => {
    return userFolder.toLowerCase() === 'export customer'
}

export const isEuropeDealar = (userFolder = '') => {
    return userFolder.toLowerCase() === 'europe dealers'
}